import { useTeamMemberMe } from "~/components/team-member/composables/useTeamMember";
import { useApi } from "~/composables/useApi";
import type { BaseOrganization } from "@asap/shared/types/organization";

export const useConsultantDefaultOrganization = () => {
  const { invoke } = useApi();
  const { teamMember } = useTeamMemberMe();

  const consultantDefaultOrganization = ref<BaseOrganization | null>(null);
  const isConsultantDefaultOrganizationLoading = ref(false);

  const loadConsultantDefaultOrganization = async (): Promise<BaseOrganization | null> => {
    const businessUnitId = teamMember.value?.business_unit_id;
    if (!businessUnitId) {
      consultantDefaultOrganization.value = null;
      return null;
    }

    isConsultantDefaultOrganizationLoading.value = true;
    try {
      const response = await invoke({
        path: "organization/find",
        method: "GET",
        query: { businessUnitId },
      });

      if (!response.success || !response.data) {
        consultantDefaultOrganization.value = null;
        return null;
      }

      consultantDefaultOrganization.value = response.data;
      return response.data;
    } finally {
      isConsultantDefaultOrganizationLoading.value = false;
    }
  };

  return {
    consultantDefaultOrganization,
    isConsultantDefaultOrganizationLoading,
    loadConsultantDefaultOrganization,
  };
};
